import useSelector from '@app/hooks/useSelector';

import { getExportNullAsOptions } from '../../../../reducers/downloadData/selectors';
import type { ExportNullAs } from '../../../../types';
import ExportNullAsInput from './ExportNullAsInput';

export interface ExportNullAsInputContainerProps {
    value: ExportNullAs;
    onChange: (value: ExportNullAs) => void;
}

const ExportNullAsInputContainer = ({ value, onChange }: ExportNullAsInputContainerProps) => {
    const exportNullAsOptions = useSelector(getExportNullAsOptions);

    return <ExportNullAsInput value={value} options={exportNullAsOptions} onChange={onChange} />;
};

export default ExportNullAsInputContainer;
